
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destination-promoters",
      function () {
        return require("private-next-pages/destination-promoters/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destination-promoters"])
      });
    }
  